import { RouteConfig } from 'vue-router';

import { eventsRoute } from './events/list.route';
import { eventDetailsRoute } from './events/details.route';

export const eventsContainerRoute: RouteConfig = {
  path: 'events',
  component: () =>
    import(/* webpackChunkName: "Router" */ '@/components/Router.vue'),
  children: [eventsRoute, eventDetailsRoute]
};
